import { CallToAction, Card, Grid, Header, Heading, Icon, TextAndMedia } from '@boltenergy-be/design-system'
import { Trans, useTranslation } from 'next-i18next/pages'
import StartSimulationButton from 'components/start-simulation-button/StartSimulationButton'
import styles from './UspsCustomerCare.module.scss'
import UspTestimonials from 'features/usps/components/testimonials/UspTestimonials'
import Vnr from 'components/review-ratings/assets/Vnr'

const UspsCustomerCare = () => {
  // i18n
  const { t } = useTranslation('usps', { keyPrefix: 'care' })

  return (
    <main>
      <Header title={t('header.title')} color="accent-soft" shape="s2">
        <p>{t('header.description')}</p>
      </Header>

      <TextAndMedia
        aboveTitleSlot={
          <strong className="mb-400">
            <Trans
              {...{ t }}
              i18nKey="intro.review"
              components={{
                star: <Icon name="star" size={14} />,
                logo: <Vnr height={13} className="ml-100" />
              }}
            />
          </strong>
        }
        title={t('intro.title')}
        media={{
          type: 'image',
          imageBehaviour: '1-1',
          props: { publicId: '/website/usps/care', fill: true, alt: '' }
        }}
      >
        <p>{t('intro.description')}</p>
        <StartSimulationButton />
      </TextAndMedia>

      <Grid title={t('cards.title')}>
        <Card color="soft" key="quickResponse" className={styles.card}>
          <Icon name="electricity" size={32} />
          <div className="flex-col gap-200">
            <Heading as="h2" variant="h4" serif>
              {t('cards.quickResponse.title')}
            </Heading>
            <p>{t('cards.quickResponse.description')}</p>
          </div>
        </Card>

        <Card color="soft" key="realPeople" className={styles.card}>
          <Icon name="peopleHeart" size={32} />
          <div className="flex-col gap-200">
            <Heading as="h2" variant="h4" serif>
              {t('cards.realPeople.title')}
            </Heading>
            <p>{t('cards.realPeople.description')}</p>
          </div>
        </Card>

        <Card color="soft" key="feedbackWelcome" className={styles.card}>
          <Icon name="chatBubbles" size={32} />
          <div className="flex-col gap-200">
            <Heading as="h2" variant="h4" serif>
              {t('cards.feedbackWelcome.title')}
            </Heading>
            <p>{t('cards.feedbackWelcome.description')}</p>
          </div>
        </Card>
      </Grid>

      <CallToAction title={t('cta.title')} color="dark" shape="s6" action={<StartSimulationButton />}>
        <p>{t('cta.description')}</p>
      </CallToAction>

      <UspTestimonials
        ratings={{ googleReviews: true }}
        reviews={t('testimonials.reviews', { returnObjects: true }) as Array<{ text: string; author: string }>}
      />
    </main>
  )
}

export default UspsCustomerCare
